import { ErrorAlert } from "./alert";

export const validateEnv = () => {
  const required = [
    'VITE_REDIRECT_URL',
    'VITE_API_URL', 
    'VITE_AUTH_ENV_AUTHORITY',
    'VITE_AUTH_ENV_CLIENTID',
    'VITE_ENVIRONMENT',
  ];
  
  const missing = required.filter(key => !import.meta.env[key]);
  if (missing.length > 0) {
    ErrorAlert('Environment Variables Error', `Missing environment variables: ${missing.join(', ')}`);
  }
};